import { render, staticRenderFns } from "./page-foot.vue?vue&type=template&id=11c13a2c&"
import script from "./page-foot.vue?vue&type=script&lang=js&"
export * from "./page-foot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports